import { render, staticRenderFns } from "./SearchCase.vue?vue&type=template&id=2dbf7598&scoped=true&"
import script from "./SearchCase.vue?vue&type=script&lang=js&"
export * from "./SearchCase.vue?vue&type=script&lang=js&"
import style0 from "./SearchCase.vue?vue&type=style&index=0&id=2dbf7598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf7598",
  null
  
)

export default component.exports